import { PencilIcon } from '@heroicons/react/24/outline'
import { useNavigate } from 'react-router-dom'

const ShopDetails = ({ shop, isComplete }) => {
  const navigate = useNavigate()

  const getMessage = () => {
    if (isComplete) {
      return (
        <p className="text-gray-600 text-sm">
          Here is your shop details. Please review carefully and edit if necessary.
        </p>
      )
    } else {
      return (
        <p className="text-gray-600 text-sm">
          Your shop details are incomplete. The following fields are required: Shop Name, Building
          Name, Floor, and Shop Number. Please fill out the required fields.
        </p>
      )
    }
  }

  return (
    <div className="relative">
      <div className="mb-6 p-4 bg-neutral-200-50 rounded-lg border border-gray-200">
        <div className="flex flex-col md:flex-row items-start justify-between gap-4">
          <div className="flex-1">{getMessage()}</div>
          <button
            onClick={() => navigate(`/my-shop/edit`)}
            className="flex-shrink-0 inline-flex items-center gap-2 bg-secondary-600 text-white rounded-lg px-4 py-2 text-sm font-medium shadow-sm hover:bg-secondary-600/90 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-secondary-600 focus:ring-offset-2"
          >
            <PencilIcon className="w-4 h-4" />
            Edit Shop Details
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
        <div>
          <span className="text-gray-600 font-medium">Shop Name:</span>
          <div>{shop?.shopName || '—'}</div>
        </div>
        <div>
          <span className="text-gray-600 font-medium">Building Name:</span>
          <div>{shop?.buildingName || '—'}</div>
        </div>
        <div>
          <span className="text-gray-600 font-medium">Floor:</span>
          <div>{shop?.floor || '—'}</div>
        </div>
        <div>
          <span className="text-gray-600 font-medium">Shop Number:</span>
          <div>{shop?.shopNumber || '—'}</div>
        </div>
      </div>
    </div>
  )
}
export default ShopDetails
